var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DBF227",
    d: "M44.3,-74.1C57.6,-69.2,68.4,-57.5,73.6,-44C78.8,-30.5,78.4,-15.3,77.7,-0.4C77,14.4,76,28.9,70.4,41.7C64.8,54.5,54.6,65.7,42.1,73.7C29.6,81.8,14.8,86.7,0.9,85.1C-12.9,83.5,-25.9,75.4,-39.5,68C-53.1,60.6,-67.4,53.8,-74.5,42.6C-81.6,31.4,-81.6,15.7,-80.3,0.7C-79,-14.3,-76.6,-28.5,-69.6,-40C-62.7,-51.5,-51.3,-60.3,-38.9,-65.7C-26.6,-71.2,-13.3,-73.4,1.1,-75.4C15.6,-77.4,31.1,-79.1,44.3,-74.1Z",
    transform: "translate(100 100)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBlob);
export default __webpack_public_path__ + "static/media/test-blob.c3d95a6b5ba14d561bf1123e9a6ef41c.svg";
export { ForwardRef as ReactComponent };